import { render, staticRenderFns } from "./wrestler_charges_feed.vue?vue&type=template&id=82c32236&"
import script from "./wrestler_charges_feed.vue?vue&type=script&lang=js&"
export * from "./wrestler_charges_feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports